var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoneyhub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "130 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logo",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M151.395769,6.00317934 L142.434167,10.9966463 L151.423322,15.9450123 L153.655952,12.212615 C154.117223,11.4415058 154.114445,10.4930677 153.648969,9.72422816 L151.395769,6.00317934 Z",
    id: "Fill-7",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.543954,9.95630042 L140.516326,0.0144674507 L136.030495,0.0258159064 C135.103824,0.0280855976 134.249001,0.504427876 133.787805,1.27553714 L131.5551,5.00793441 L140.543954,9.95630042 Z",
    id: "Fill-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.268295,0 L146.260937,0 L141.774656,0.0113484558 L141.802209,9.95318142 L150.763886,4.95971446 L148.51061,1.23829956 C148.046336,0.47172968 147.191888,0 146.268295,0",
    id: "Fill-11",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.928968,6.05489901 L128.695963,9.78766236 C128.235143,10.5584055 128.23747,11.5068436 128.702945,12.2756832 L133.841568,20.7616923 C134.306668,21.5301658 135.164193,22.0022615 136.090865,21.9999919 L146.321186,21.9742931 C147.247858,21.9719502 148.103056,21.4956811 148.564252,20.7245719 L150.796957,16.9918085 L130.928968,6.05489901 Z",
    id: "Fill-13"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyhub);
export default __webpack_public_path__ + "static/media/moneyhub.f522ab619c89ef48a1fcc81322c381f3.svg";
export { ForwardRef as ReactComponent };